<template>
    <span>{{dictText ? dictText: defaultText}}</span>
</template>

<script>
    export default {
        name: "DictText",
        props:{
            defaultText:{
                type: String,
                default:'(无)'
            },
            dictValue: {
                type: String,
                default:''
            },
            typeFlag:{
                type: String,
                default:''
            }
        },
        watch:{
            value:{
              deep:true,
              handler:function () {
                  this.selectValue = this.value;
              }
            },
            selectValue:{
                deep:true,
                handler:function () {
                    this.$emit('input',this.selectValue);
                }
            }
        },
        computed:{
            dictText(){

                let vm = this;
                let dict = this.dict.find((r)=>{return r.flag === vm.typeFlag });

                if(dict){

                    let dictItem = dict.dictItems.find((item) => {return item.dictValue === vm.dictValue});

                    if(dictItem){
                        return  dictItem.name;
                    }else{
                        return '';
                    }

                }else{
                    return '';
                }
            }
        },
        data(){
            return {
                dict:[],
                selectValue:[],
            }
        },
        created() {

            let vm = this;

            if(!window.dictPromise){
                window.dictPromise = new Promise((res)=>{
                    vm.$http.post(vm.$api.dictType.allDict).then((resp)=>{
                        res(resp)
                    });
                })
            }

            window.dictPromise.then((resp)=>{
                vm.dict = resp.data.data.dictTypes;
            })



        }
    }
</script>

<style scoped>

</style>